export default __webpack_public_path__ + "static/media/kohut-3.1fa9e34b.jpg";